import { helper } from '@ember/component/helper';

// query-params builds the query parameter bag that consumers expect as a
// trailing argument:
//
//   {{href-to "admin.pages" (query-params type="student")}}
//
// Ember shipped a helper of this name until 4.0, where it became a
// `{{link-to}}`-only keyword with no runtime helper behind it. Everywhere else
// - `{{href-to}}`, closure actions, `<LinkTo>`'s positional query params - the
// call resolves through the app's own helpers, so we own it now.
//
// `isQueryParams` is the flag consumers switch on, and `values` is where they
// read the params from, both here and in ember-source's own `<LinkTo>` and
// `-routing` service.
export default helper(function queryParams(positional, named) {
  return { isQueryParams: true, values: { ...named } };
});
